<app-menu class="menuApp" xmlns="http://www.w3.org/1999/html"></app-menu>
<div class="main">
  <div style="padding-top: 2vh; width: 90%; margin: auto; text-align: center">

    <div style="width: 45%; margin: auto;">
      <h3 class="textXM" style="text-align: center; border-bottom: 2px solid #18264f">
        {{this.localiser.get("ota.title")}}
      </h3>
    </div>

    <div class="row">

      <div class="col-3 searcherDiv">
          <span class="material-icons-outlined textXXM centerVert" style="color: #18264F; width: 15%; height: 65%">
            search
          </span>
        <input [(ngModel)]="searcherLuminarias" type="text" class="textS searcherInput centerVert"
               placeholder="{{this.localiser.get('ota.search')}}" (input)="checkAllFilters()" maxlength="50">
      </div>

      <div class="col-3">
        <mat-select (selectionChange)="selectPlano($event.value)" [(ngModel)]="planoSelected" [placeholder]="this.localiser.get('ota.filterFloorplan')" class="selectFilter textS">
          <mat-option class="textS+" [value]="'all'"><b>{{this.localiser.get("ota.filterAll")}}</b></mat-option>
          <mat-option class="textS+" *ngFor="let plano of planos" [value]="plano">{{plano.nombre}}</mat-option>
        </mat-select>
      </div>

      <div class="col-3">
        <mat-select (selectionChange)="selectZona($event.value)" [(ngModel)]="zonaSelected" [placeholder]="this.localiser.get('ota.filterZone')" class="selectFilter textS">
          <mat-option class="textS+" [value]="'all'"><b>{{this.localiser.get("ota.filterAll")}}</b></mat-option>
          <mat-option class="textS+" *ngFor="let zona of showZonas" [value]="zona">{{zona.nombre}}</mat-option>
        </mat-select>
      </div>

      <div class="col-3">
        <mat-select (selectionChange)="selectVersionFilter($event.value)" [(ngModel)]="versionFilterSelected" [placeholder]="this.localiser.get('ota.filterVersion')" class="selectFilter textS">
          <mat-option class="textS+" [value]="'all'"><b>{{this.localiser.get("ota.filterAll")}}</b></mat-option>
          <mat-option class="textS+" *ngFor="let version of versiones" [value]="version">{{version}}</mat-option>
        </mat-select>
      </div>
    </div>


    <div class="row">

      <!-- Luminaire list Col -->
      <div class="col-6" style="margin-top: 1%">
        <h4 class="textS+" style="text-decoration: underline; margin: auto;">
        {{this.localiser.get("ota.lumList")}}
      </h4>
        <div class="luminariasList">
          <div *ngFor="let luminaria of this.luminarias; index as i" class="luminariaBox">
            <div (click)="changeSelectLum(luminaria)" class="row luminariaRow">
              <div class="row luminariaRowUp">
                <div class="col-7 luminariaColRight">
                  <h3 class="centerVert textS marginAuto">{{luminaria.nombre}}</h3>
                </div>
                <div class="col-5">
                  <div class="lumIdActions">
                    <h3 class="textS lumIdText">{{luminaria.idDispositivo}}</h3>
                    <button class="peripheralsButton" (click)="openPeripherals(luminaria, $event)" matTooltip="Peripherals" [matTooltipPosition]="'above'">
                      <span class="material-icons-outlined textS">settings_input_component</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="row luminariaRowBottom">
                <div class="col-3 textS luminariaColRight">
                  <div class="row marginAuto">
                    <h3 class="textS luminariaRowTextTitle">{{this.localiser.get("ota.filterFloorplan")}}</h3>
                  </div>
                  <div class="row marginAuto">
                    <h3 class="textS luminariaRowText">{{getPlanoNameById(luminaria.idPlano)}}</h3>
                  </div>
                </div>
                <div class="col-3 textS luminariaColRight">
                  <div class="row marginAuto">
                    <h3 class="textS luminariaRowTextTitle">{{this.localiser.get("ota.filterZone")}}</h3>
                  </div>
                  <div class="row marginAuto">
                    <h3 class="textS luminariaRowText">{{getZonaNameById(luminaria.idZona)}}</h3>
                  </div>
                </div>
                <div class="col-3 textS luminariaColRight">
                  <div class="row marginAuto">
                    <h3 class="textS luminariaRowTextTitle">{{this.localiser.get("ota.filterVersion")}}</h3>
                  </div>
                  <div class="row marginAuto">
                    <h3 class="textS luminariaRowText">{{luminaria.versionFirmware}}</h3>
                  </div>
                </div>
                <div class="col-3 textS">
                  <div class="row marginAuto">
                    <h3 class="textS luminariaRowTextTitle" [matTooltip]="this.localiser.get('ota.lastOTATooltip')"
                        [matTooltipPosition]="'above'">{{this.localiser.get("ota.lastOTA")}}</h3>
                  </div>
                  <div class="row marginAuto">
                    <h3 class="textS luminariaRowText">{{getFechaOTACorrecta(luminaria)}}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>

      <!-- Selected Luminaire list Col -->
      <div class="col-6" style="margin-top: 1%">

        <div class="selectedLuminariasList">


          <!-- Lum(s) doing OTA -->
          <div *ngIf="lumForOTA.length > 0">

            <div class="row titleLumList">
              <div class="col-12">
                <h4 class="textS+ centerVert" style="margin: auto; text-decoration: underline;">
                  {{this.localiser.get("ota.queueOTA")}}
                </h4>
              </div>
            </div>

            <!-- Lum doing OTA -->
            <div *ngFor="let luminaria of this.lumForOTA; index as i" class="luminariaBox">

              <div style="display: flex">
                <div class="col-12 luminariaSelectedRow selectedRow">
                  <div class="col-10 firstSelectedLuminaireRowBorder">
                    <div class="row luminariaRowUp">
                      <div class="col-7 luminariaColRight">
                        <h3 class="centerVert textS marginAuto">{{luminaria.nombre}}</h3>
                      </div>
                      <div class="col-5">
                        <div class="lumIdActions">
                          <h3 class="textS lumIdText">{{luminaria.idDispositivo}}</h3>
                          <button class="peripheralsButton peripheralsButtonLight" (click)="openPeripherals(luminaria, $event)" matTooltip="Peripherals" [matTooltipPosition]="'above'">
                            <span class="material-icons-outlined textS">settings_input_component</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- INFO: Floorplan - Zone - Version - Last OTA -->
                    <div class="row luminariaSelectedRowMid">
                      <div class="col-3 textS luminariaColRight">
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowTextTitle">{{this.localiser.get("ota.filterFloorplan")}}</h3>
                        </div>
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowText">{{getPlanoNameById(luminaria.idPlano)}}</h3>
                        </div>
                      </div>
                      <div class="col-3 textS luminariaColRight">
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowTextTitle">{{this.localiser.get("ota.filterZone")}}</h3>
                        </div>
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowText">{{getZonaNameById(luminaria.idZona)}}</h3>
                        </div>
                      </div>
                      <div class="col-3 textS luminariaColRight">
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowTextTitle">{{this.localiser.get("ota.filterVersion")}}</h3>
                        </div>
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowText">{{luminaria.versionFirmware}}</h3>
                        </div>
                      </div>
                      <div class="col-3 textS">
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowTextTitle" [matTooltip]="this.localiser.get('ota.lastOTATooltip')"
                              [matTooltipPosition]="'above'">{{this.localiser.get("ota.lastOTA")}}</h3>
                        </div>
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowText">{{getFechaOTACorrecta(luminaria)}}</h3>
                        </div>
                      </div>
                    </div>

                    <!-- INFO: RSSI - Loss rate -->
                    <div *ngIf="luminaria.otaEstado.estado.includes('Updating')" class="row luminariaSelectedRowMid">
                      <div class="col-6 textS luminariaColRight">
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowTextTitle">RSSI</h3>
                        </div>
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowText">{{getRSSIOta(luminaria)}}</h3>
                        </div>
                      </div>
                      <div class="col-6 textS luminariaColRight">
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowTextTitle">Loss Rate</h3>
                        </div>
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowText">{{getLossRateOta(luminaria)}}% ({{getLossRateFractionOta(luminaria)}})</h3>
                        </div>
                      </div>
                    </div>

                    <!-- INFO BANNER -->
                    <div class="row luminariaSelectedRowBottom">
                      <h3 class="textS luminariaRowTextTitle">{{getStatusText(luminaria)}}</h3>
                      <h3 class="textS luminariaRowText" style="margin: 1% 0">{{luminaria.otaEstado.firmwareOTA}}</h3>
                    </div>

                  </div>

                  <!-- RIGHT VISUAL BAR -->
                  <div *ngIf="luminaria.otaEstado.estado == 'Waiting' || luminaria.otaEstado.estado == 'Connecting' || luminaria.otaEstado.estado == 'Aborting'" class="col-2">
                    <mat-progress-spinner class="spinner centerVert" mode="indeterminate" diameter="50">
                    </mat-progress-spinner>
                  </div>
                  <div *ngIf="luminaria.otaEstado.estado.includes('Updating') || luminaria.otaEstado.estado == 'Waiting' || luminaria.otaEstado.estado == 'Installing'" class="col-2" style="padding: 1.5%">
                    <div style="position: relative; width: 100%; height: 100%;">
                      <div id="progressBar-{{luminaria.idDispositivo}}" style="position: absolute; width: 94%; height: 0%; margin-left: 3%; margin-bottom: 4%;
                      bottom: 0; background-color: #F2A356; border-radius: 5px">
                      </div>
                      <div style="position: absolute; width: 100%; height: 100%; background-color: rgba(1,1,1,0); border: 4px solid white; border-radius: 10px">
                        <h3 class="centerVert textS+" style="margin: auto; text-align: center">{{getProgressNew(luminaria)}}%</h3>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>

          <!-- Finished OTA lums -->
          <div *ngIf="finishedOTALums.length > 0">

            <div class="row titleLumList">
              <div class="col-10">
                <h4 class="textS+ centerVert" style="margin: auto; text-decoration: underline;">
                  {{this.localiser.get("ota.queueFinished")}}
                </h4>
              </div>
              <div class="col-2">
                <span (click)="openFinishedListFunc()" *ngIf="!openFinishedList" class="material-icons-outlined textXM centerVert"
                      style="cursor: pointer">add_circle</span>
                <span (click)="openFinishedListFunc()" *ngIf="openFinishedList" class="material-icons-outlined textXM centerVert"
                      style="cursor: pointer">do_not_disturb_on</span>
              </div>
            </div>

            <div *ngIf="openFinishedList">
              <div *ngFor="let luminaria of this.finishedOTALums; index as i" class="luminariaBox">

              <div style="display: flex">
                <div class="col-12 luminariaSelectedRow selectedRow">
                  <div class="col-10 firstSelectedLuminaireRowBorder">

                    <div class="row luminariaRowUp">
                      <div class="col-7 luminariaColRight">
                        <h3 class="centerVert textS marginAuto">{{luminaria.nombre}}</h3>
                      </div>
                      <div class="col-5">
                        <div class="lumIdActions">
                          <h3 class="textS lumIdText">{{luminaria.idDispositivo}}</h3>
                          <button class="peripheralsButton peripheralsButtonLight" (click)="openPeripherals(luminaria, $event)" matTooltip="Peripherals" [matTooltipPosition]="'above'">
                            <span class="material-icons-outlined textS">settings_input_component</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="row luminariaSelectedRowMid">
                      <div class="col-3 textS luminariaColRight">
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowTextTitle">{{this.localiser.get("ota.filterFloorplan")}}</h3>
                        </div>
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowText">{{getPlanoNameById(luminaria.idPlano)}}</h3>
                        </div>
                      </div>
                      <div class="col-3 textS luminariaColRight">
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowTextTitle">{{this.localiser.get("ota.filterZone")}}</h3>
                        </div>
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowText">{{getZonaNameById(luminaria.idZona)}}</h3>
                        </div>
                      </div>
                      <div class="col-3 textS luminariaColRight">
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowTextTitle">{{this.localiser.get("ota.filterVersion")}}</h3>
                        </div>
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowText">
                            <span *ngIf="showVersionOrigen(luminaria)">{{luminaria.otaEstado.versionOrigen}} &#8594; </span>{{luminaria.versionFirmware}}
                          </h3>
                        </div>
                      </div>
                      <div class="col-3 textS">
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowTextTitle" [matTooltip]="this.localiser.get('ota.lastOTATooltip')"
                              [matTooltipPosition]="'above'">{{this.localiser.get("ota.lastOTA")}}</h3>
                        </div>
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowText">{{getFechaOTACorrecta(luminaria)}}</h3>
                        </div>
                      </div>
                    </div>

                    <!-- INFO BANNER -->
                    <div class="row luminariaSelectedRowBottom">
                      <h3 class="textS luminariaRowTextTitle">{{getStatusText(luminaria)}}</h3>
                      <h3 class="textS luminariaRowText" style="margin: 1% 0">{{luminaria.otaEstado.firmwareOTA}}</h3>
                    </div>

                  </div>

                  <!-- RIGHT VISUAL BAR -->
                  <div *ngIf="luminaria.otaEstado.estado.includes('Done') && checkVersionOTA(luminaria)" class="col-2" style="padding: 1.5%;
                  background-color: limegreen; border-radius: 0 5px 5px 0;">
                  <span class="centerVert material-icons-outlined textXM" style="cursor: pointer"
                        (click)="changeSelectLum(luminaria)">done</span>
                  </div>
                  <div *ngIf="luminaria.otaEstado.estado.includes('Done') && !checkVersionOTA(luminaria)" class="col-2 otaVersionWarning"
                       [matTooltip]="this.localiser.get('ota.versionMismatch')" [matTooltipPosition]="'above'">
                  <span class="centerVert material-icons-outlined textXM" style="cursor: pointer"
                        (click)="changeSelectLum(luminaria)">warning</span>
                  </div>
                  <div *ngIf="luminaria.otaEstado.estado.includes('Error')" class="col-2" style="padding: 1.5%;
                  background-color: #FF0C41; border-radius: 0 5px 5px 0;">
                  <span class="centerVert material-icons-outlined textXM" style="cursor: pointer"
                        (click)="changeSelectLum(luminaria)">close</span>
                  </div>

                </div>
              </div>
            </div>
            </div>
          </div>

          <!-- Queue for OTA -->
          <div *ngIf="queueOTALums.length > 0">

            <div class="row titleLumList">
              <div class="col-10">
                <h4 class="textS+ centerVert" style="margin: auto; text-decoration: underline;">
                  {{this.localiser.get("ota.queue")}}
                </h4>
              </div>
              <div class="col-2">
                <span (click)="openQueueListFunc()" *ngIf="!openQueueList" class="material-icons-outlined textXM centerVert"
                      style="cursor: pointer">add_circle</span>
                <span (click)="openQueueListFunc()" *ngIf="openQueueList" class="material-icons-outlined textXM centerVert"
                      style="cursor: pointer">do_not_disturb_on</span>
              </div>
            </div>

            <div *ngIf="openQueueList">
              <div *ngFor="let luminaria of this.queueOTALums; index as i" class="luminariaBox">

              <div style="display: flex">
                <div class="col-11 luminariaSelectedRow">
                  <div class="col-12">

                    <div class="row luminariaRowUp">
                      <div class="col-7 luminariaColRight">
                        <h3 class="centerVert textS marginAuto">{{luminaria.nombre}}</h3>
                      </div>
                      <div class="col-5">
                        <div class="lumIdActions">
                          <h3 class="textS lumIdText">{{luminaria.idDispositivo}}</h3>
                          <button class="peripheralsButton" (click)="openPeripherals(luminaria, $event)" matTooltip="Peripherals" [matTooltipPosition]="'above'">
                            <span class="material-icons-outlined textS">settings_input_component</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="row luminariaSelectedRowMid">
                      <div class="col-3 textS luminariaColRight">
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowTextTitle">{{this.localiser.get("ota.filterFloorplan")}}</h3>
                        </div>
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowText">{{getPlanoNameById(luminaria.idPlano)}}</h3>
                        </div>
                      </div>
                      <div class="col-3 textS luminariaColRight">
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowTextTitle">{{this.localiser.get("ota.filterZone")}}</h3>
                        </div>
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowText">{{getZonaNameById(luminaria.idZona)}}</h3>
                        </div>
                      </div>
                      <div class="col-3 textS luminariaColRight">
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowTextTitle">{{this.localiser.get("ota.filterVersion")}}</h3>
                        </div>
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowText">{{luminaria.versionFirmware}}</h3>
                        </div>
                      </div>
                      <div class="col-3 textS">
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowTextTitle" [matTooltip]="this.localiser.get('ota.lastOTATooltip')"
                              [matTooltipPosition]="'above'">{{this.localiser.get("ota.lastOTA")}}</h3>
                        </div>
                        <div class="row marginAuto">
                          <h3 class="textS luminariaRowText">{{getFechaOTACorrecta(luminaria)}}</h3>
                        </div>
                      </div>
                    </div>

                    <!-- INFO BANNER -->
                    <div class="row luminariaSelectedRowBottom">
                      <h3 class="textS luminariaRowTextTitle">{{this.localiser.get("ota.selectFirmware")}}</h3>
                      <mat-select class="luminariaSelectedFirmware textS" (selectionChange)="setFirmware(luminaria, $event.value)" [(ngModel)]="luminaria.otaEstado.firmwareOTA"
                                  (openedChange)="openFirmwareSelect(luminaria, $event, firmwareSearcher)">
                        <div class="firmwareSearcherDiv" (click)="$event.stopPropagation()">
                          <span class="material-icons-outlined textS centerVert firmwareSearcherIcon">search</span>
                          <input #firmwareSearcher [(ngModel)]="searcherFirmwares" [ngModelOptions]="{standalone: true}"
                                 type="text" class="textS firmwareSearcherInput" autocomplete="off" maxlength="50"
                                 placeholder="{{this.localiser.get('ota.searchFirmware')}}"
                                 (keydown)="searcherFirmwaresKeydown($event)">
                          <button type="button" class="peripheralsButton firmwareSortButton" (click)="changeSortFirmwares(firmwareSearcher)"
                                  [matTooltip]="getSortFirmwaresTooltip()" [matTooltipPosition]="'above'">
                            <span class="material-icons-outlined textS">{{getSortFirmwaresIcon()}}</span>
                          </button>
                        </div>
                        <mat-option *ngFor="let firmware of getFirmwaresByLum(luminaria)" class="textS" [value]="firmware.nombre">{{firmware.nombre}}</mat-option>
                        <div *ngIf="getFirmwaresByLum(luminaria).length == 0" class="textS firmwareSearcherEmpty">{{this.localiser.get("ota.searchFirmwareEmpty")}}</div>
                      </mat-select>
                    </div>

                  </div>
                </div>

                <div class="col-1">
                  <span class="material-icons-outlined textXM" style="cursor: pointer"
                        (click)="changeSelectLum(luminaria)">close</span>
                  <span *ngIf="queueOTALums.indexOf(luminaria) != 0 && !this.automaticOTAstarted" class="material-icons-outlined textXM" style="cursor: pointer" (click)="setLumForOTA(luminaria)">arrow_upward</span>
                  <span *ngIf="queueOTALums.indexOf(luminaria) == 0 && !this.automaticOTAstarted" class="material-icons-outlined textXM">looks_one</span>
                </div>


              </div>
            </div>
            </div>

          </div>

        </div>

      </div>

      <div class="row" style="max-height: 10%; width: 80%; margin: 2% auto">
        <div *ngIf="showButtonOTA()" class="col" style="margin: auto">
          <button class="customButtonColor otaButton" (click)="buttonActualizacion(0)">
            <h3 class="textS marginAuto">{{this.localiser.get("ota.start")}}</h3>
          </button>
        </div>
        <div *ngIf="showButtonOTA()" class="col" style="margin: auto">
          <button class="customButtonColor otaButton" (click)="buttonActualizacion(1)">
            <h3 class="textS marginAuto">{{this.localiser.get("ota.start.two")}}</h3>
          </button>
        </div>
        <div *ngIf="showButtonAbortOTA() || this.automaticOTAstarted" class="col" style="margin: auto">
          <button class="customButtonColorDelete otaButton" (click)="abortOTA()">
            <h3 class="textS marginAuto">{{this.localiser.get("ota.abort")}}</h3>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="peripheralsBackdrop" *ngIf="selectedPeripheralLuminaire" (click)="closePeripherals()">
  <div class="peripheralsModal" (click)="$event.stopPropagation()">
    <div class="peripheralsPanelHeader">
      <h4 class="textS+" style="margin: auto 0; text-align: left">
        {{selectedPeripheralLuminaire.nombre}} ({{selectedPeripheralLuminaire.idDispositivo}})
      </h4>
      <button class="peripheralsCloseButton" (click)="closePeripherals()">
        <span class="material-icons-outlined textXM">close</span>
      </button>
    </div>

    <div class="peripheralsTableWrapper">
      <table style="width: 100%; white-space: nowrap">
        <tr class="bottom-border">
          <th *ngFor="let peripheral of peripheralColumns"
              matTooltip="{{this.localiser.get(peripheral.tooltip)}}"
              [matTooltipPosition]="'above'"
              class="separator">
            {{peripheral.label}}
          </th>
        </tr>
        <tr style="text-align: center">
          <td *ngFor="let peripheral of peripheralColumns" class="separator">
            <span *ngIf="getPeripheralState(selectedPeripheralLuminaire, peripheral.key) == -1" class="material-icons-outlined textM">horizontal_rule</span>
            <span *ngIf="getPeripheralState(selectedPeripheralLuminaire, peripheral.key) == 0" class="material-icons-outlined textM">done</span>
            <span *ngIf="getPeripheralState(selectedPeripheralLuminaire, peripheral.key) == 1" class="material-icons-outlined textM otaPeripheralWarning">warning</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
